import React, { useState } from "react";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import styled from "@emotion/styled";
import { BiFoodMenu } from "react-icons/bi";
import { IoPeopleCircleOutline } from "react-icons/io5";

const TableInfo = () => {
    const language = React.useContext(LanguageContext);
    const themeContext = React.useContext(ThemeContext);
    const { lanIndex, reserveData, tableLabel, pax, isInRoom } = React.useContext(UserContext);

    return (
        <React.Fragment>
            <HeaderDisplay themeContext={themeContext}>
                <Wrapper>
                    <IconWraper>
                        <BiFoodMenu fontSize={24} />
                    </IconWraper>
                    <Content themeContext={themeContext} style={{ marginLeft: 8 }}>
                        <SubContent>{language[lanIndex].table}</SubContent>
                        <b>{isInRoom ? "In Room Dining":tableLabel}</b>
                    </Content>
                </Wrapper>
                <Wrapper>
                    <IconWraper>
                        <IoPeopleCircleOutline fontSize={24} />
                    </IconWraper>
                    <Content themeContext={themeContext} style={{ marginLeft: 8 }}>
                        <SubContent>{language[lanIndex].guest}</SubContent>
                        <b>{pax}</b>
                    </Content>
                </Wrapper>
            </HeaderDisplay>
        </React.Fragment>
    )



}

export default TableInfo;

const Content = styled.div`
    
`;
const SubContent = styled.div`
    font-size: 12px;
`;
//Styled Components
const HeaderDisplay = styled.div`
   margin: 0 16px;
   padding:8px;
   border: 1px solid;
   border-radius: 6px;
   margin-bottom: 8px;
   display: flex;
`;
const Wrapper = styled.div`
    display:flex;
    align-items: center;
    margin-right: 16px;
`;
const IconWraper = styled.div`
   
`;

